// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"5c6c068138500a5ad46e","678":"aea24fef559041f32a11"}[chunkId] + ".js";
};